var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-booking-card-list',{staticClass:"layout-padding",attrs:{"bookings-user":_vm.$route.params.username}})}
var staticRenderFns = []

export { render, staticRenderFns }